export const MandatoryLabel = ({
  label,
  mandatory,
}: {
  label: string;
  mandatory: boolean;
}) => {
  return <><span>{label}</span>{mandatory && <span className="text-red-500">*</span>}</>
}